module.exports = __webpack_public_path__ + "img/article2-mob.afb38837.png";